var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"is-position-relative height-151"},[_c('img',{staticClass:"image logo-img",attrs:{"src":_vm.logo ? _vm.logo : '/static/img/default-placeholder.png',"alt":"Logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }